import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import { marginSize } from '../../Utilities/utils/Theming';

export const BreadcrumbsStylesListItems = (theme: typeof Theme) => {
	return {
		fontSize: 'var(--epods--font-size-p)',
		color: 'var(--epods--color-text-primary)',
		lineHeight: 'var(--epods--line-height-p)',
		fontFamily: 'var(--epods--font-base)',
		display: 'flex',
		alignItems: 'center',
	};
};

export const BreadcrumbsStylesList = (theme: typeof Theme) => {
	return {
		display: 'flex',
		alignItems: 'center',
		flex: '0 1 auto',
		minWidth: '0',
		flexWrap: 'wrap' as any,
	};
};

export const breadcrumbsBaseStyle = (theme: typeof Theme) => {
	return {
		...marginSize('0', '0', '0', '0'),
		display: 'flex',
		fontSize: 'var(--epods--font-size-p)',
		color: 'var(--epods--color-text-primary)',
		lineHeight: 'var(--epods--line-height-p)',
		fontFamily: 'var(--epods--font-base)',
		border: 'none',
		listStyleType: 'none',
		alignItems: 'last baseline',
		flex: '0 1 auto',
		minWidth: '0',
	};
};

export const breadcrumbsSeparatorStyle = (theme: typeof Theme) => {
	return {
		color: theme.breadcrumbs.separatorColor,
		marginLeft: theme.breadcrumbs.separatorMargin,
		marginRight: theme.breadcrumbs.separatorMargin,
		display: 'inline-flex'
	};
};

export const breadcrumbsHomeIconStyle = (theme: typeof Theme) => {
	return {
		fontSize: '18px',
		color: theme.colors.blueGrey500 + ' !important',
	};
};

// Added the line height because of vertical alignment
export const breadcrumbsLastItemStyle = () => {
	return {
		lineHeight: '23px',
	};
};
